import React, { useRef } from "react";
import TechnologyTiles, {
  TechnologyTileItem,
} from "@/common/technologycard/TechnologyTiles";

interface TechStackItem {
  id: number;
  content: string;
  iconImage: string;
}

type Variant = "green" | "blue";

interface TechStackCardProps {
  variant?: Variant;
  items: TechStackItem[];
  sectionTitle?: string;
  index: number;
  openIndex: number | null;
  setOpenIndex: (index: number | null) => void;
}

const TechStackCard: React.FC<TechStackCardProps> = ({
  variant = "blue",
  items,
  sectionTitle,
  index,
  openIndex,
  setOpenIndex,
}) => {

  const borderColor =
    variant === "green" ? "border-green-50" : "border-blue-50";

  const strokeColor =
    variant === "green" ? "stroke-green-500" : "stroke-text-button";

  const borderColorCard =
    variant === "green"
      ? "border-green-100 hover:border-green-100"
      : "border-blue-100 hover:border-blue-500";

  const isOpen = openIndex === index;

  const handleToggle = () => {
    if (isOpen) {
      setOpenIndex(null); // close if already open
    } else {
      setOpenIndex(index); // open this one
    }
  };
  const contentRef = useRef<HTMLDivElement>(null);
  return (
    <div className={`border ${borderColor}`}>
      <div
        className={`md:block hidden p-4 ${variant === "green" ? "bg-green-50" : "bg-blue-50"}`}
      >
        <h3 className={`text-subtitle-2 font-bold text-primary-text`}>
          {sectionTitle}
        </h3>
      </div>
      <div
        className={`md:hidden flex justify-between items-center p-4 ${variant === "green" ? "bg-green-50" : "bg-blue-50"}`}
        onClick={handleToggle}
      >
        <h3 className={`text-subtitle-2 font-bold text-primary-text`}>
          {sectionTitle}
        </h3>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={`origin-center transition-all duration-300 ${isOpen ? "rotate-90" : "rotate-0"}`}
        >
          <path
            d="M8.91003 19.9201L15.43 13.4001C16.2 12.6301 16.2 11.3701 15.43 10.6001L8.91003 4.08008"
            stroke={`${strokeColor}`}
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={`${strokeColor}`}
          />
        </svg>
      </div>

      <div
        className="overflow-hidden md:max-h-[100%_!important] transition-all duration-300"
        ref={contentRef}
        style={
          isOpen
            ? { maxHeight: contentRef.current?.scrollHeight }
            : { maxHeight: 0 }
        }
      >
        <TechnologyTiles
          context="servicesInner"
          variant={variant}
          items={items.map<TechnologyTileItem>((item) => ({
            id: item?.id,
            title: item?.content,
            iconUrl: item?.iconImage,
          }))}
          gridClassName="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 xl:gap-[18px] gap-[16px] py-4 md:px-4 px-[17px]"
          tileContainerClasses={`xl:aspect-[180_/_135] lg:aspect-[166_/_135] aspect-[166_/_135] w-auto flex items-center justify-center relative bg-white border group ${borderColorCard}`}
          titleClassName="text-start text-subtitle-1 font-regular w-full text-secondary-text md:px-[15px] md:pt-[15px] px-[5px] pt-[5px] sm:line-clamp-none"
          iconWrapperClassName="absolute bottom-0 right-0 w-fit items-center justify-end md:px-2.5 md:pb-2.5 px-0.5 pb-0.5"
        />
      </div>
    </div>
  );
};

export default TechStackCard;
